import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../lib/metrika";

// Слушает изменения роута в BrowserRouter и отправляет hit в Метрику.
// Первая загрузка страницы трекается базовым кодом счётчика в <head>,
// поэтому пропускаем самый первый рендер.
export const MetrikaRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // даём небольшую задержку, чтобы document.title успел обновиться через useSEO
    const timer = setTimeout(() => {
      trackPageView(window.location.href);
    }, 100);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
};
